import * as React from 'react';
import { useCallback } from 'react';
import { Stack } from '@mui/material';
import AppBarPage from '../components/AppBarPage';
import { useTwilioCall } from '../hooks/useTwilio';
import { Location, useLocation } from 'react-router';
import { ContactProps } from '../components/ContactForm';
import { ModeLink } from '../components/ModeButton';
import { HeadsetMic, PhoneEnabled, Wifi } from '@mui/icons-material';
import PhoneCallDialog from '../components/CallDialog';

const SupportPage = (): JSX.Element => {
    const loc: Location<ContactProps | undefined> = useLocation();
    const { dial, hangup, status } = useTwilioCall(
        (loc.state && {
            user_name: `${loc.state.firstName} ${loc.state.lastName}`,
            company_name: loc.state.orgName || '',
            plan_name: loc.state.planName || '',
            service_type: loc.state.serviceType || ''
        }) || {}
    );
    const onDialClick = useCallback(() => {
        dial('+16468468237');
    }, [dial]);


    return (
        <AppBarPage title='Support Call'>
            <Stack direction='column' spacing={2} sx={{ maxWidth: '480px', margin: '16px auto 0' }}>
                <Stack direction='column' spacing={2} sx={{ maxWidth: '480px', margin: '16px auto 0' }}>
                    <ModeLink
                        to='tel:+16468468237'
                        title='Phone' icon={<PhoneEnabled />} description='Call to the real phone'
                    />
                    <ModeLink
                        to='sip:+16468468237@ziphy.sip.twilio.com'
                        title='SIP' icon={<Wifi />} description='Call using SIP'
                    />
                    <ModeLink
                        onClick={onDialClick} to='#'
                        title='Web' icon={<HeadsetMic />} description='Use web-based call'
                    />
                </Stack>
            </Stack>
            <PhoneCallDialog 
                open={status !== ''} 
                onClose={hangup} 
                title='Calling...' text={status} />
        </AppBarPage>
    )
}
export default SupportPage;